import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { BulkProposalCard } from './BulkProposalCard';
import type { ChatCommandPayload } from './chat-proposal.types';

interface Props {
  title: string;
  proposalId: string;
  payload: ChatCommandPayload;
  resolved?: string | undefined;
  onConfirm: (proposalId: string) => void;
  onCancel: (proposalId: string) => void;
}

/** Confirmation card for one action applied to a list of records. */
export function ChatCommandProposalCard({
  title,
  proposalId,
  payload,
  resolved,
  onConfirm,
  onCancel
}: Props) {
  const t = useFeatureTranslation('aiChat');

  return (
    <BulkProposalCard
      title={title}
      description={t('proposals.chat.countDescription', { count: payload.items.length })}
      proposalId={proposalId}
      rows={payload.items}
      rowKey={row => row.id}
      primary={row => <span className='font-medium'>{row.number}</span>}
      footer={
        payload.note !== null ? (
          <p className='m-0 text-sm text-foreground-subtle'>
            {t('proposals.chat.note', { note: payload.note })}
          </p>
        ) : undefined
      }
      resolved={resolved}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
